import {Image, Modal} from "antd";
import "./style.less"
import React, {FC} from "react";
import FeedbacksList from "../../feedbacks-list/FeedbacksList";
import {StaffDetailModalProps} from "../../../types/staff";
import {getImageLink} from "../../../helpers/mainHelpers";
import * as BUCKETS from "../../../enums/buckets"
import TextReader from "../../text-reader/TextReader";
import {useAuth} from "../../../context/authContext";
import {FileProtectOutlined, IdcardOutlined, MedicineBoxOutlined, StarOutlined} from "@ant-design/icons";

const StaffDetailModal: FC<StaffDetailModalProps> = ({staffController}) => {
  const {toggleDetailModal, selectedStaff, isDetailModalOpen} = staffController
  const {isLoggedIn} = useAuth()

  const closeModalHandler = () => {
    toggleDetailModal({isModalOpen: false, selectedStaff: undefined})
  }

  const isFeedbacksVisible = Boolean(isLoggedIn && staffController.feedbacksList.length)

  return <Modal
    centered
    width={900}
    onCancel={closeModalHandler}
    className="staff-detail-modal"
    open={isDetailModalOpen}
    footer={null}
    title={<span className="staff-detail-modal__modal-title"><IdcardOutlined/> Профіль лікаря</span>}
  >
    {selectedStaff && <article className="staff-profile">
      <div className="staff-profile__main">
        <div className="staff-profile__visual">
          <div className="staff-profile__portrait">
            {selectedStaff.image
              ? <img className="staff-profile__image"
                     src={getImageLink({imageId: selectedStaff.image, bucketId: BUCKETS.MAIN})}
                     alt={`Фото: ${selectedStaff.fullName}`}/>
              : <div className="staff-profile__placeholder" aria-hidden="true">
                {selectedStaff.fullName?.trim().charAt(0) || "Л"}
              </div>}
          </div>
          <div className="staff-profile__visual-accent" aria-hidden="true"/>
        </div>

        <div className="staff-profile__content">
          <div className="staff-profile__eyebrow"><MedicineBoxOutlined/> Лікар нашої команди</div>
          <h2 className="staff-profile__name">{selectedStaff.fullName}</h2>
          <p className="staff-profile__position">{selectedStaff.position}</p>

          {selectedStaff.about && <section className="staff-profile__about" aria-labelledby="staff-about-title">
            <h3 className="staff-profile__section-title" id="staff-about-title">Про лікаря</h3>
            <div className="staff-profile__divider"/>
            <TextReader value={selectedStaff.about}/>
          </section>}
        </div>
      </div>

      {Boolean(selectedStaff.certificates?.length) && <section className="staff-profile__extra-section" aria-labelledby="certificates-title">
        <header className="staff-profile__extra-header">
          <FileProtectOutlined/>
          <h3 id="certificates-title">Сертифікати</h3>
        </header>
        <div className="staff-profile__certificates">
          <Image.PreviewGroup>
            {selectedStaff.certificates.map((imageId, index) => <div className="staff-profile__certificate" key={imageId || index}>
              <Image
                className="staff-profile__certificate-image"
                src={getImageLink({imageId, bucketId: BUCKETS.MAIN})}
                alt={`Сертифікат ${index + 1}: ${selectedStaff.fullName}`}
              />
            </div>)}
          </Image.PreviewGroup>
        </div>
      </section>}

      {isFeedbacksVisible && <section className="staff-profile__extra-section" aria-labelledby="feedbacks-title">
        <header className="staff-profile__extra-header">
          <StarOutlined/>
          <h3 id="feedbacks-title">Відгуки пацієнтів</h3>
        </header>
        <div className="staff-profile__feedbacks">
          <FeedbacksList confirmDeleteFeedback={staffController.confirmDeleteFeedback}
                         isLoading={staffController.isLoading} feedbacksList={staffController.feedbacksList}/>
        </div>
      </section>}
    </article>}
  </Modal>
}

export default StaffDetailModal
